import { useAppSelector } from "../app/hooks";
import { RootState } from "../app/store";

type StatusSlice = {
  status?: string;
  [key: string]: any;
};

const useIsLoading = (slices: (keyof RootState | string)[]) => {
  const state = useAppSelector((state) => state) as Record<
    keyof RootState,
    StatusSlice
  >;

  const isLoading = slices.some((sliceInput) => {
    let sliceName: keyof RootState;
    let subSlice: string | undefined;

    // check if sliceInput contains a dot = slice is a subSlice
    if (typeof sliceInput === "string" && sliceInput.includes(".")) {
      const parts = sliceInput.split(".");
      sliceName = parts[0] as keyof RootState;
      subSlice = parts[1];
    } else {
      sliceName = sliceInput as keyof RootState;
    }

    const sliceState = state[sliceName];

    // if subSlice is defined, check the loading status of the subSlice
    if (subSlice) {
      return sliceState[subSlice]?.status === "pending";
    }
    // check the loading status of the root slice
    return sliceState.status === "pending";
  });

  return isLoading;
};

export default useIsLoading;
